import type { FunctionComponent, ReactNode } from "react";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

export type Props = {
  children?: ReactNode;
  replace?: boolean;
  selector: string;
};

export const Portal: FunctionComponent<Props> = ({ children, replace = false, selector }) => {
  const [replaced, setReplaced] = useState(false);
  const [element, setElement] = useState<Element>();

  useEffect(() => {
    const targetElement = document.querySelector(selector);
    if (!targetElement) return;

    setElement(targetElement);

    if (replace && !replaced) {
      targetElement.innerHTML = "";
      setReplaced(true);
    }
  }, [replace, replaced, selector]);

  return element ? createPortal(children, element) : null;
};

Portal.displayName = "Portal";
